export default class NotificationDomain {
  id: string;

  title: string;

  message: string;

  deepLink: string;

  read: boolean;

  createdAt: string;

  // Set when a later message updated a grouped entry (one per conversation).
  updatedAt: string | null;

  // Messages since the entry was last read; 1 for an ungrouped entry.
  itemCount: number;

  conversationId: number | null;

  constructor(
    id: string,
    title: string,
    message: string,
    deepLink: string,
    read: boolean,
    createdAt: string,
    updatedAt: string | null,
    itemCount: number,
    conversationId: number | null
  ) {
    this.id = id;
    this.title = title;
    this.message = message;
    this.deepLink = deepLink;
    this.read = read;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.itemCount = itemCount;
    this.conversationId = conversationId;
  }
}
